import React from "react";
import { LegalLayout } from "@/pages/LegalLayout";
import { LINKS } from "@/lib/brand";

export default function Datenschutz() {
  return (
    <LegalLayout
      title="Datenschutzerklärung"
      subtitle="Informationen nach Art. 13 DSGVO"
    >
      <section data-testid="ds-verantwortlich" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          1. Verantwortliche Stelle
        </h2>
        <p>
          Simone Faller
          <br />
          Grünewalder Str. 19
          <br />
          42657 Solingen
          <br />
          E-Mail:{" "}
          <a
            href={`mailto:${LINKS.email}`}
            className="text-paula-red hover:underline"
          >
            {LINKS.email}
          </a>
        </p>
      </section>

      <section data-testid="ds-grundsatz" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          2. Datenminimierung
        </h2>
        <p>
          Diese Website ist eine reine Informationsseite. Es gibt kein
          Kontaktformular, kein Benutzerkonto, keine Kommentarfunktion und
          keinen Warenkorb. Kontaktaufnahme erfolgt ausschließlich über den
          angegebenen mailto-Link. Es werden keine Cookies gesetzt und kein
          Tracking/Analytics eingesetzt.
        </p>
      </section>

      <section data-testid="ds-server-logs" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          3. Server-Logfiles
        </h2>
        <p>
          Beim Aufruf dieser Website erhebt der Hosting-Anbieter automatisch
          technische Informationen, die Dein Browser übermittelt:
        </p>
        <ul className="list-disc pl-6 mt-3 space-y-1">
          <li>IP-Adresse (gekürzt/anonymisiert, soweit möglich)</li>
          <li>Datum und Uhrzeit des Zugriffs</li>
          <li>Browsertyp und -version</li>
          <li>Betriebssystem</li>
          <li>Referrer-URL (die zuvor besuchte Seite)</li>
          <li>Übertragene Datenmenge</li>
        </ul>
        <p className="mt-3">
          Diese Daten sind technisch notwendig, um die Website auszuliefern und
          Sicherheit zu gewährleisten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f
          DSGVO (berechtigtes Interesse an einer sicheren und stabilen
          Website).
        </p>
      </section>

      <section data-testid="ds-hosting" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          4. Hosting
        </h2>
        <p>
          Diese Website wird bei{" "}
          <span className="font-semibold">Emergent</span> gehostet
          (paula-landing.emergent.host). Der Anbieter verarbeitet
          Server-Logdaten wie oben beschrieben zum Zweck des Betriebs der
          Website. Ein Auftragsverarbeitungsvertrag nach Art. 28 DSGVO besteht
          bzw. kann angefragt werden.
        </p>
      </section>

      <section data-testid="ds-fonts" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          5. Schriftarten (Fonts)
        </h2>
        <p>
          Die auf dieser Website verwendeten Schriftarten „Outfit" und „Work
          Sans" werden{" "}
          <span className="font-semibold">lokal vom eigenen Server</span>{" "}
          geladen. Es besteht keine Verbindung zu Google Fonts oder anderen
          externen Font-Diensten. Deine IP-Adresse wird nicht an Dritte
          übermittelt.
        </p>
      </section>

      <section data-testid="ds-external-media" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          6. Externe Bilder und CDN
        </h2>
        <p>
          Illustrationen, Fotos und der QR-Code werden über das
          Content-Delivery-Netzwerk von Emergent ausgeliefert
          (customer-assets.emergentagent.com). Beim Laden der Bilder wird Deine
          IP-Adresse an diesen Dienst übertragen, um die Bilder auszuliefern.
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
          Interesse an schneller, weltweiter Bereitstellung der Inhalte).
        </p>
      </section>

      <section data-testid="ds-links" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          7. Externe Links
        </h2>
        <p>
          Diese Website enthält Links zu externen Anbietern wie Shopify,
          Amazon, Radio RSG, Solinger Tageblatt und der Kinder-App
          notfall-werkstatt.emergent.host. Beim Klicken auf diese Links
          verlässt Du diese Seite. Für die Datenverarbeitung auf den
          verlinkten Seiten sind die jeweiligen Anbieter verantwortlich. Ich
          empfehle, dort die Datenschutzhinweise zu prüfen.
        </p>
      </section>

      <section data-testid="ds-cookies" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          8. Cookies
        </h2>
        <p>
          Diese Website setzt <span className="font-semibold">keine Cookies</span>{" "}
          und verwendet <span className="font-semibold">kein Tracking</span>,
          weder für Analysezwecke noch für Werbung.
        </p>
      </section>

      <section data-testid="ds-rechte" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          9. Deine Rechte
        </h2>
        <p>Als betroffene Person hast Du folgende Rechte:</p>
        <ul className="list-disc pl-6 mt-3 space-y-1">
          <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
          <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
          <li>Recht auf Löschung (Art. 17 DSGVO)</li>
          <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruchsrecht (Art. 21 DSGVO)</li>
        </ul>
        <p className="mt-3">
          Zur Ausübung dieser Rechte reicht eine formlose E-Mail an{" "}
          <a
            href={`mailto:${LINKS.email}`}
            className="text-paula-red hover:underline"
          >
            {LINKS.email}
          </a>
          .
        </p>
      </section>

      <section data-testid="ds-beschwerde" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          10. Beschwerderecht bei der Aufsichtsbehörde
        </h2>
        <p>
          Du hast das Recht, Dich bei einer Datenschutzaufsichtsbehörde zu
          beschweren. Für Simone Faller ist zuständig:
        </p>
        <p className="mt-3">
          Landesbeauftragte für Datenschutz und Informationsfreiheit
          Nordrhein-Westfalen
          <br />
          Kavalleriestr. 2–4, 40213 Düsseldorf
          <br />
          <a
            href="https://www.ldi.nrw.de"
            target="_blank"
            rel="noopener noreferrer"
            className="text-paula-red hover:underline"
          >
            www.ldi.nrw.de
          </a>
        </p>
      </section>

      <p className="text-sm text-paula-muted mt-12">
        Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}
      </p>
    </LegalLayout>
  );
}
